export const DataUsagePurposeBase = () => {
  return (
    <>
      ア.　(1)に定める第三者が、契約者のニーズや興味、関心に合うと考える商品・サービスの提案及び広告のため（商品・サービスの提案及び広告は、(1)に定める第三者が行います。）
      <br />
      イ.　指定サービスの利用状況等の調査・分析、各種販売施策実施のための調査・分析及び当該施策の効果測定、新商品・新サービスに関する企画開発・調査・分析、サービス品質改善・応対サービス向上のための調査・分析、融資審査のための調査・分析・モニタリングその他各種調査・分析の実施のため
      <br />
      ウ.　利用者からのご意見・ご要望・お問合せ等への対応のため
      <br />
      エ.　不正契約・不正利用・不払いの発生防止及び発生時の調査及び対応のため
    </>
  );
};

export const DataUsagePurposeJPBank = () => {
  return (
    <>
      ア.　(1)に定める第三者が、契約者のニーズや興味、関心に合うと考える商品・サービスの提案及び広告のため（商品・サービスの提案及び広告は、(1)に定める第三者が行います。）
      <br />
      イ.　指定サービスの利用状況等の調査・分析、各種販売施策実施のための調査・分析及び当該施策の効果測定、新商品・新サービスに関する企画開発・調査・分析、サービス品質改善・応対サービス向上のための調査・分析その他各種調査・分析の実施のため
      <br />
      ウ.　利用者からのご意見・ご要望・お問合せ等への対応のため
      <br />
      エ.　不正契約・不正利用・不払いの発生防止及び発生時の調査及び対応のため
    </>
  );
};

export const DataUsagePurposeInsuranceAgency = () => {
  return (
    <>
      ア.　(1)に定める第三者が、契約者のニーズや興味、関心に合うと考える商品・サービスの提案及び広告のため（商品・サービスの提案及び広告は、(1)に定める第三者が行います。）
      <br />
      イ.　指定サービスの利用状況等の調査・分析、各種販売施策実施のための調査・分析及び当該施策の効果測定、新商品・新サービスに関する企画開発・調査・分析、サービス品質改善・応対サービス向上のための調査・分析
      <br />
      ウ.　保険商品の開発のため（保険商品の開発は、(1)に定める第三者が行います。）
      <br />
      エ.　法人、団体又は個人事業主が特定されない情報として加工処理を行い、地方自治体、法人又は団体へ提供及び販売するため（提供および販売は、(1)に定める第三者が行います。）
      <br />
      オ.　(1)に定める第三者が、契約者の指定サービスの利用状況を分析・可視化し、(1)に定める第三者及び(1)に定める第三者が委託する者を通じて、契約者へ提供するため
      <br />
      カ.　契約者の指定サービスの利用状況と、(1)に定める第三者が契約者と別途締結する保険契約の事故状況との相関性を検証し、リスクマネジメントを行うため（リスクマネジメントは、(1)に定める第三者が行います。）
      <br />
      キ.　利用者からのご意見・ご要望・お問合せ等への対応のため
      <br />
      ク.　不正契約・不正利用・不払いの発生防止及び発生時の調査及び対応のため
    </>
  );
};
